import { GetZonesResponse } from '../shared/ExamModuleTypes';
import {
	GetRegionsRequest,
	GetZonesRequest,
	PreceptorApplicationCentralTeamDashboardRequest,
	PreceptorApplicationCentralTeamDashboardResponse,
} from '../shared/ScreeningServiceTypes';
import { GetRegionsResponse } from '../shared/VolunteerApplicationServiceTypes';
import { volunteerServiceClient } from './HTTPClient';

export const getRegionsOfPreceptorApplications = async (
	request: GetRegionsRequest
): Promise<GetRegionsResponse> => {
	const response = await volunteerServiceClient.post<GetRegionsResponse>(
		'getRegionsOfPreceptorApplications',
		request
	);
	return response.data;
};

export const getZonesOfPreceptorApplications = async (
	request: GetZonesRequest
): Promise<GetZonesResponse> => {
	const response = await volunteerServiceClient.post<GetZonesResponse>(
		'getZonesOfPreceptorApplications',
		request
	);
	return response.data;
};

export const getCentralTeamDashboardDetail = async (
	request: PreceptorApplicationCentralTeamDashboardRequest
): Promise<PreceptorApplicationCentralTeamDashboardResponse> => {
	const response =
		await volunteerServiceClient.post<PreceptorApplicationCentralTeamDashboardResponse>(
			'getCentralTeamDashboardDetail',
			request
		);
	return response.data;
};
